import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/servico-motivo',
  name: 'servico-motivo',
  component: Index,
  children: [
    { path: 'listar', name: 'servico-motivo-listar', component: Listar },
    { path: 'novo', name: 'servico-motivo-novo', component: Novo },
    { path: ':id', name: 'servico-motivo-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'servico-motivo-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/servico-motivo/routes.js